import type { Routes } from "@angular/router";
import { MainLayoutComponent } from "@layout/main-layout/main-layout.component";
import { healthScreeningGuard } from "./guards/health-screening.guard";

export default [
	{
		path: "health-screening",
		component: MainLayoutComponent,
		children: [
			{
				path: "",
				loadComponent: () =>
					import("./health-screening.component").then(
						(c) => c.HealthScreeningComponent,
					),
			},
			{
				path: "scores",
				loadComponent: () =>
					import(
						"./health-screening-scores/health-screening-scores.component"
					).then((c) => c.HealthScreeningScoresComponent),
			},
			{
				path: "scores/:areaId",
				loadComponent: () =>
					import(
						"./health-screening-score-details/health-screening-score-details.component"
					).then((c) => c.HealthScreeningScoreDetailsComponent),
			},
			{
				path: "priorities",
				loadComponent: () =>
					import(
						"./health-screening-priorities/health-screening-priorities.component"
					).then((c) => c.HealthScreeningPrioritiesComponent),
			},
			{
				path: ":areaId",
				loadComponent: () =>
					import(
						"./health-screening-priority/health-screening-priority.component"
					).then((c) => c.HealthScreeningPriorityComponent),
			},
		],
		canActivate: [healthScreeningGuard],
	},
] satisfies Routes;
